module.exports = __webpack_public_path__ + "static/media/zoom-in.6a404a1e.svg";